import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { DownloadImportSmall } from '@wix/wix-ui-icons-common';
import { FC } from 'react';
import { REVIEW_SUMMARY_DATA_HOOKS } from '../ReviewSummary';

interface PurchaseCountProps {
  purchaseCount: number;
  isMini?: boolean;
  isFree?: boolean;
}

const PurchaseCount: FC<PurchaseCountProps> = ({
  isMini,
  purchaseCount,
  isFree,
}) => {
  if (isMini) {
    return <PurchaseCountMini purchaseCount={purchaseCount} />;
  }

  return <PurchaseCountLarge purchaseCount={purchaseCount} isFree={isFree} />;
};

export default PurchaseCount;

type CountRenderProps = Pick<PurchaseCountProps, 'purchaseCount'> & {
  isFree?: boolean;
};

const PurchaseCountMini: FC<CountRenderProps> = ({ purchaseCount }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const ratingNumberFormatter = Intl.NumberFormat(language, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format;

  return (
    <Box>
      <DownloadImportSmall />
      <Text size="small">{ratingNumberFormatter(purchaseCount)}</Text>
    </Box>
  );
};

const PurchaseCountLarge: FC<CountRenderProps> = ({
  purchaseCount,
  isFree,
}) => {
  const { t } = useTranslation();
  return (
    <Text
      size="small"
      weight="thin"
      dataHook={REVIEW_SUMMARY_DATA_HOOKS.purchaseCount}
    >
      {t(
        isFree
          ? 'marketplace.templates-page.hero-section.free-purchase-count'
          : 'marketplace.templates-page.hero-section.purchase-count',
        {
          number: purchaseCount ?? 0,
        },
      )}
    </Text>
  );
};
